module.exports = "<a class=\"offers\" href=\"#\" (click)=\"openOffersDialog($event)\">\n  {{ 'SHOW_OFFERS' | translate }}\n</a>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/app/components/map-config-offers/map-config-offers.component.html
// module id = ../../../../../src/app/components/map-config-offers/map-config-offers.component.html
// module chunks = main